import { Route, Routes } from 'react-router-dom';

import { ErrorPage } from '~/components/ErrorPage';
import { env } from '~/lib/env';
import { useUser } from '~/modules/auth/hooks/useUser';
import { TabsPagesLayout } from '~settings/components';

import { CreateUserPage } from './pages/CreateUserPage';
import { DetailUserPage } from './pages/DetailUserPage';
import { EditUserPage } from './pages/EditUserPage';
import { ListUserPage } from './pages/ListUserPage';

export function UserRouter() {
  const { hasPermission } = useUser();
  const manageExternalUserEnabled =
    env('VITE_CONTAINER_SETTINGS_MANAGE_EXTERNAL_USER_ENABLED', false) ===
    'true';
  const canCreateUser =
    hasPermission('USER.CREATE') && manageExternalUserEnabled;
  const canEditUser = hasPermission('USER.EDIT') && manageExternalUserEnabled;

  return (
    <Routes>
      <Route element={<TabsPagesLayout />}>
        <Route path="/" element={<ListUserPage />} />
      </Route>
      <Route
        path="create"
        element={
          canCreateUser ? <CreateUserPage /> : <ErrorPage type="noAccessPage" />
        }
      />
      <Route
        path=":userId/edit"
        element={
          canEditUser ? <EditUserPage /> : <ErrorPage type="noAccessPage" />
        }
      />

      <Route path=":userId" element={<DetailUserPage />} />
      <Route path="*" element={<ErrorPage type="notFoundPage" />} />
    </Routes>
  );
}

UserRouter.displayName = 'UserRouter';
